import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-wrapper">

        {/* Le nom au-dessus */}
        <p className="footer-name">Meta Yachts Services</p>

        <div className="footer-container-row">
          {/* Bloc gauche : infos */}
          <div className="footer-info">
            <p>
              <a href="tel:+33603536593">+33 (0)6 03 53 65 93</a><br />
              <a href="mailto:metayachtsservices@gmail.com">metayachtsservices@gmail.com</a>
            </p>

            <p>
              <a
                href="https://www.google.com/maps/@43.3845556,4.8359999,17z"
                target="_blank"
                rel="noopener noreferrer"
              >
                📍 Voir sur la carte — Port-Saint-Louis-du-Rhône
              </a>
            </p>

            <div className="footer-socials">
              <a
                href="https://www.instagram.com/meta_yachts_services"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/METAPSLDR"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.youtube.com/@metayachtsservices3579"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>

            <p className="footer-copy">
              &copy; {new Date().getFullYear()} Meta Yachts Services — Tous droits réservés
            </p>

            <div className="footer-links">
              <a href="/mentions-legales">Mentions légales</a>
              <span> | </span>
              <a href="/politique-confidentialite">Politique de confidentialité</a>
            </div>
            <div className='footer-links'>
              <a href='/admin'>Admin</a>
            </div>
          </div>

          {/* Bloc droit : carte */}
          <div className="footer-map">
            <iframe
              title="Meta Yachts Services - Carte"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11757.5!2d4.8359999!3d43.3845556!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDIzJzA0LjQiTiA0wrA1MCcwOS42IkU!5e0!3m2!1sfr!2sfr!4v1721400000000"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
